import type from './type'

export default {
  progress(context,show){
    context.commit(type.PROGRESS,show);
  },
  alert(context, data){
    context.commit(type.ALERT,data);
  },
  userDetail(context, data){
    context.commit(type.USER_DETAIL,data);
  }
}
